// @flow

import React from "react";
import { connect } from "react-redux";
import {
  QuickLinksComponent,
  mapStateToProps,
  mapDispatchToProps
} from "@tvg/quick-links";
import QuickLinksTemplate from "@fdr/atomic-ui/_templates/QuickLinks";
import type { QuickLink } from "@tvg/types/Links";
import mediator from "@tvg/mediator";

export class FDRQuickLinks extends QuickLinksComponent {
  onLinkClick = (link: QuickLink) => {
    mediator.base.dispatch({
      type: "BANNER_CAROUSEL_CLICKED",
      payload: {
        linkUrl: link.url,
        bannerType: link.url.includes("/tutorials") ? "tutorial" : "promo",
        bannerName: link.label,
        bannerId: `SGW-${link.label}`,
        linkText: link.imageURL
      }
    });
  };

  render() {
    const processedLinks =
      this.props.quickLinks.length > 0
        ? this.props.quickLinks
        : this.processLinksData(this.props.quickLinksData);
    return (
      // $FlowFixMe
      <QuickLinksTemplate
        quickLinks={this.formatQuickLinks(processedLinks)}
        onLinkClick={this.onLinkClick}
        isInApp={this.state.isApp}
        enableNewDerbyDesign={this.props.enableNewDerbyDesign}
        bigSpace={this.props.withoutBackground}
      />
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(FDRQuickLinks);
